import Button from "../utils/Button";
import InputText from "../utils/InputText";
import classes from "./LoginForm.module.css";
import { Link } from "react-router-dom";
import { useState } from "react";

import useUserStore from "../store/useUserStore";
import showPass from "../assests/images/show.png";
import hidePass from "../assests/images/hide.png";

export default function LoginForm() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const { login } = useUserStore((state) => state);
  const [show, setShow] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    const newFormData = { ...formData };
    newFormData[name] = value;
    setFormData(newFormData);
  };

  const loginSubmitHandler = (event) => {
    event.preventDefault();
    login(formData);
  };

  const handleChangeShowHidePass = () => setShow((state) => !state);

  return (
    <form className={classes.loginForm} onSubmit={loginSubmitHandler}>
      <InputText
        placeholder="E-mail"
        onChange={handleChange}
        name="email"
        style={{ width: "100%" }}
        required="required"
      />
      <div className={classes.inputPass}>
        <InputText
          style={{ width: "100%" }}
          type={show ? "text" : "password"}
          placeholder="Password"
          onChange={handleChange}
          name="password"
          required="required"
        />
        <div className={classes.showHidePass}>
          <img
            onClick={handleChangeShowHidePass}
            width="100%"
            alt="show"
            src={show ? showPass : hidePass}
          />
        </div>
      </div>

      <Button style={{ width: "100%" }}>Login</Button>
      <Link to="/signup">Don´t have Account</Link>
    </form>
  );
}
